export default "__VITE_ASSET__rp7CZxUp__"